import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitTrafficModel } from '@apps-common/types/portal/unit'

export const QUERY_GET_UNIT_TRAFFIC_SIGNAL_STRENGTH = (identifiers?: string, startDate?: string, skip?: number, take?: number) =>
  ['getUnitTrafficSignalStrength', identifiers, startDate, skip, take].filter(Boolean)

export const getUnitTrafficSignalStrength = async (
  identifiers: string,
  skip: number,
  take: number,
  startDate?: string
): Promise<IUnitTrafficModel[]> =>
  axios
    .get(
      `/unit/GetUnitTrafficSignalStrength?identifiers=${identifiers}&skip=${skip}&take=${take}${startDate ? `&startDate=${startDate}` : ''}`
    )
    .then((res) => res.data?.data)

type QueryFnType = typeof getUnitTrafficSignalStrength

type Props = {
  config?: QueryConfig<QueryFnType>
  identifiers: string
  startDate?: string
  skip: number
  take: number
}

export const useGetUnitTrafficSignalStrength = ({ config, identifiers, startDate, skip, take }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_GET_UNIT_TRAFFIC_SIGNAL_STRENGTH(identifiers, startDate, skip, take),
    queryFn: () => getUnitTrafficSignalStrength(identifiers, skip, take, startDate)
  })
